const style = (theme) => {
  const output = {
    root: {
      position: 'fixed',
      zIndex: theme.zindex.modal,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: theme.colors[0],
      opacity: 0,
      display: 'none',
    },
    content: {
      overflowY: 'auto',
      maxHeight: '100vh',
    },
    close: {
      position: 'fixed',
      zIndex: 20,
      width: 46,
      height: 46,
      border: `1px solid ${theme.getRgba(theme.colors[1], 0.2)}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      outline: 'none',
      borderRadius: '50%',
      top: 19,
      right: 19,
      '& svg': {
        fill: theme.colors[1],
        width: 10,
        height: 10,
      },
    },

    videoWrap: {
      position: 'relative',
      zIndex: 1,
      height: '100vh',
      width: '100vw',
    },
    video: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      transform: 'translate(-50%, -50%)',
    },
  }


  return output
}

export default style
